module.exports = __webpack_public_path__ + "static/media/FAQs.a3cfdabc.gif";